import { Typography } from '@mui/material';
import { LoadingBox, Page } from '@/components/common';
import { useDonationsEnabled } from '@/hooks/useDonationsEnabled';

/**
 * Renders donation screens only when the `EnableDonations` feature flag is on.
 * While flags load it shows a loader; when off it shows an unavailable message
 * (and the wrapped screen never mounts, so no data is fetched).
 */
export function DonationGate({ children }) {
  const { enabled, isLoading } = useDonationsEnabled();

  if (isLoading) {
    return (
      <Page>
        <LoadingBox />
      </Page>
    );
  }

  if (!enabled) {
    return (
      <Page>
        <Typography variant="h2">Donations are not available.</Typography>
      </Page>
    );
  }

  return children;
}
